import React from 'react';

const ContactIcon = () => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.12319 7H8.06522M4.2971 7H5.23913M9.94928 7H10.8913M5.71014 11.9928L7.5942 14.9909L9.47826 11.9928H13.2464C13.7673 11.9928 14.1884 11.5461 14.1884 10.9935V1.99935C14.1884 1.44671 13.7673 1 13.2464 1H1.94203C1.42109 1 1 1.44671 1 1.99935V10.9935C1 11.5461 1.42109 11.9928 1.94203 11.9928H5.71014Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ContactIcon;
